export default IconMathXy => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-math-xy" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 9l3 5.063" />
  <path d="M4 9l6 6" />
  <path d="M4 15l6 -6" />
  <path d="M20 9l-4.8 9" />
</svg>`;